<template>
    <div class="party-member">
        <div class="identity">{{ identity }}</div>
        <div class="organization">{{ organization }}</div>
        <div class="member-info-list">
            <div class="member-info member-info-small">
                <div class="member-info-left">性别</div>
                <div class="member-info-right">{{ sexText }}</div>
            </div>
            <div class="member-info member-info-small">
                <div class="member-info-left">年龄</div>
                <div class="member-info-right">{{ age }}</div>
            </div>
            <div class="member-info member-info-large">
                <div class="member-info-left">入党时间</div>
                <div class="member-info-right">{{ joinAt }}</div>
            </div>
        </div>
        <div class="my-organization-row">
            <div class="my-organization">我的组织</div>
            <div class="view-btn" @click="openOrgDialog">点击查看</div>
        </div>
        <!-- <div class="clerk">支部书记：{{ secretary }}</div>
        <div class="commissioner">支部委员：{{ committeeMembers }}</div> -->
        <el-row class="statictis">
            <el-col :span="6">
                <div class="formal-number">{{ fullPartyMembers }}</div>
                <div class="formal-member">正式党员</div>
            </el-col>
            <el-col :span="8" class="flex-column">
                <div class="preparation-member">预备党员<div class="preparation-number">{{ probationaryPartyMembers }}</div>
                </div>
                <div class="female-member">女性党员<div class="female-number">{{ femalePartyMembers }}</div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="aggressive-number">{{ activeMembers }}</div>
                <div class="aggressive-member">入党积极分子</div>
            </el-col>
        </el-row>
        <el-dialog
            title="我的组织"
            v-model="showOrgDialog"
            modal-class="org-dialog-wrap"
            width="80%"
            append-to-body
        >
            <div class="org-dialog-content">
                <div class="org-role-list">
                    <div v-for="item in orgRoleList" :key="item.id || item.label" class="org-role-item">
                        <div class="org-role-content">
                            <span class="org-role-title">{{ item.label }}</span>
                            <span class="org-role-separator">：</span>
                            <span class="org-role-name">{{ item.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { calculateAge, formatDateOnly } from '@/utils/profile'

function toAverageScore(list) {
  if (!Array.isArray(list) || list.length === 0) {
    return '--'
  }
  const total = list.reduce((sum, item) => sum + (Number(item?.val) || 0), 0)
  return Math.round((total / list.length) * 10) / 10
}

export default {
  name: 'HomeInform',
  data() {
    return {
      showOrgDialog: false
    }
  },
  props: {
    profileData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    userInfo() {
      return this.profileData?.user || this.profileData?.info || {}
    },
    orgInfo() {
      return this.profileData?.org || {}
    },
    statsInfo() {
      return this.profileData?.stats || {}
    },
    positionUserList() {
      return this.profileData?.positionUserList || []
    },
    personaTimelineList() {
      return this.profileData?.personaTimeline?.list || []
    },
    personaStatusMine() {
      return this.profileData?.personaStatus?.list?.mine || []
    },
    personaStatusMean() {
      return this.profileData?.personaStatus?.list?.mean || []
    },
    identity() {
      return this.userInfo.position_name || this.userInfo.political_status_text || '--'
    },
    organization() {
      return this.orgInfo.name || this.userInfo.org_name || '--'
    },
    sexText() {
      return this.userInfo.sex_text || '--'
    },
    age() {
      if (this.userInfo.age || this.userInfo.age === 0) {
        return String(this.userInfo.age)
      }
      return calculateAge(this.userInfo.birthday)
    },
    joinAt() {
      return formatDateOnly(this.userInfo.join_at)
    },
    positionName() {
      return this.userInfo.position_name || '--'
    },
    originate() {
      return this.userInfo.originate || '--'
    },
    secretary() {
      return this.orgInfo.secretary || '--'
    },
    committeeMembers() {
      return this.orgInfo.committee_members || '--'
    },
    fullPartyMembers() {
      const value = this.statsInfo.full_party_members
      return value || value === 0 ? String(value) : '--'
    },
    probationaryPartyMembers() {
      const value = this.statsInfo.probationary_party_members
      return value || value === 0 ? String(value) : '--'
    },
    femalePartyMembers() {
      const value = this.statsInfo.female_party_members
      return value || value === 0 ? String(value) : '--'
    },
    activeMembers() {
      const value = this.statsInfo.active_members
      return value || value === 0 ? String(value) : '--'
    },
    myAverageScore() {
      return toAverageScore(this.personaStatusMine)
    },
    meanAverageScore() {
      return toAverageScore(this.personaStatusMean)
    },
    timelineCount() {
      return this.personaTimelineList.length || '--'
    },
    bestSingleScore() {
      if (!this.personaStatusMine.length) {
        return '--'
      }
      return this.personaStatusMine.reduce((max, item) => {
        const value = Number(item?.val) || 0
        return value > max ? value : max
      }, 0)
    },
    orgRoleList() {
      if (!Array.isArray(this.positionUserList) || this.positionUserList.length === 0) {
        return []
      }
      return this.positionUserList.map((item) => {
        const userNames = Array.isArray(item.userList)
          ? item.userList.map((user) => user.real_name).filter(Boolean)
          : []
        return {
          id: item.id,
          label: item.name || '--',
          name: userNames.length ? userNames.join('、') : '--'
        }
      })
    }
  },
  methods: {
    openOrgDialog() {
      this.showOrgDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.party-member {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    padding: 3.5vw 3.5vw;
    background: #ed6b66;
    box-shadow: 0 0.51282vw 5.12821vw rgba(0, 0, 0, 0.2);
    border-radius: 3.84615vw;
  
    .identity {
      color: white;
      font-size: 4.10256vw;
      font-weight: 600;
    }
  
    .organization {
      color: white;
      font-size: 3.07692vw;
    }
  
    .member-info-list {
      display: flex;
      justify-content: flex-start;
      gap: 3vw;
      margin-top: 2.05128vw;
    }

    .member-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      min-width: 0;
      height: 13.33333vw;
      padding: 2vw;
      background: linear-gradient(180deg, #ffe1e1 0%, #ffc7c4 100%);
      border-radius: 2.5641vw;

      &.member-info-small {
        width: 20.51282vw;
      }

      &.member-info-large {
        width: 42.82051vw;
      }
  
      .member-info-left {
        font-size: 2.5641vw;
        font-weight: 600;
        text-align: left;
        color: #b54f4b;
      }
  
      .member-info-right {
        margin-top: 0.51282vw;
        width: 100%;
        font-size: 4.10256vw;
        font-weight: 600;
        text-align: right;
        color: #b54f4b;
      }
    }
  
    .my-organization-row {
      margin-top: 2.05128vw;
      display: flex;
      align-items: center;
    }

    .my-organization {
      margin-top: 0;
      color: white;
      font-size: 4.10256vw;
      font-weight: 600;
    }

    .view-btn {
      padding: 0.76923vw 2.05128vw;
      margin-left: 4vw;
      border-radius: 3.84615vw;
      border: 0.25641vw solid #ffd2d1;
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
      font-size: 3.07692vw;
      line-height: 1;
      cursor: pointer;
    }

    .clerk {
      color: white;
      font-size: 3.07692vw;
    }
  
    .commissioner {
      color: white;
      font-size: 3.07692vw;
    }
  
    .statictis {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 2.05128vw;
      color: white;
      align-items: flex-end;
  
      .formal-number {
        font-size: 9.23077vw;
        font-weight: bold;
        text-shadow: 0.51282vw 1.02564vw 1.02564vw rgba(0, 0, 0, 0.1);
        margin-bottom: 3vw;
        text-align: center;
      }
  
      .formal-member {
        font-size: 4vw;
        font-weight: 600;
        text-align: center;
      }
  
      .flex-column {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 17vw;
      }
  
  
      .preparation-member {
        display: inline-block;
        font-size: 3.58974vw;
  
        .preparation-number {
          display: inline;
          margin-left: 1.28205vw;
          font-size: 4.61538vw;
          font-weight: bold;
          text-shadow: 0.51282vw 1.02564vw 1.02564vw rgba(0, 0, 0, 0.1);
        }
      }
  
      .female-member {
        display: inline-block;
        font-size: 3.58974vw;
  
        .female-number {
          display: inline;
          margin-left: 1.28205vw;
          font-size: 4.61538vw;
          font-weight: bold;
          text-shadow: 0.51282vw 1.02564vw 1.02564vw rgba(0, 0, 0, 0.1);
        }
      }
  
      .aggressive-number {
        width: 30.76923vw;
        font-size: 9.23077vw;
        font-weight: bold;
        text-shadow: 0.51282vw 1.02564vw 1.02564vw rgba(0, 0, 0, 0.1);
        margin-bottom: 3vw;
        text-align: center;
      }
  
      .aggressive-member {
        width: 30.76923vw;
        font-size: 4vw;
        font-weight: 600;
        text-align: center;
      }
    }
  
    .statictis .el-col:nth-child(2) {
      border-right: 0.25641vw solid #F9ABAC;
    }
  }

</style>

<style lang="scss">
.org-dialog-wrap .el-dialog {
  overflow: hidden;
  border-radius: 3.07692vw;
  border: 0.2vw solid rgba(237, 107, 102, 0.28) !important;
  box-shadow: 0 0 0 0.28vw rgba(237, 107, 102, 0.16) inset,
    0 0.6vw 2vw rgba(237, 107, 102, 0.12) !important;
  background: #fff6f5 !important;
}
</style>